// extracted by mini-css-extract-plugin
export default {"galleriesMainPage":"GalleriesPage_galleriesMainPage__HmMgV"};